// Mock data and API for blind structures development
// This allows testing the UI before backend is ready

let mockBlindStructures = [
  {
    id: 1,
    leagueId: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    name: 'Standard Tournament',
    description: '20-minute levels, deep stack structure',
    blindDuration: 20,
    blind_duration_minutes: 20,
    breakDuration: 10,
    break_duration_minutes: 10,
    breakFrequency: 4,
    break_frequency: 4,
    isDefault: true,
    is_default: true,
  },
  {
    id: 2,
    leagueId: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    name: 'Turbo Tournament',
    description: '12-minute fast-paced structure',
    blindDuration: 12,
    blind_duration_minutes: 12,
    breakDuration: 5,
    break_duration_minutes: 5,
    breakFrequency: 3,
    break_frequency: 3,
    isDefault: false,
    is_default: false,
  },
];

let mockBlindLevels = {
  1: [
    { id: 1, blindStructureId: 1, blind_structure_id: 1, levelNumber: 1, level_number: 1, smallBlind: 25, small_blind: 25, bigBlind: 50, big_blind: 50, ante: 0, isBreak: false, is_break: false, durationSeconds: 1200, duration_seconds: 1200, breakDurationSeconds: 0, break_duration_seconds: 0 },
    { id: 2, blindStructureId: 1, blind_structure_id: 1, levelNumber: 2, level_number: 2, smallBlind: 50, small_blind: 50, bigBlind: 100, big_blind: 100, ante: 0, isBreak: false, is_break: false, durationSeconds: 1200, duration_seconds: 1200, breakDurationSeconds: 0, break_duration_seconds: 0 },
    { id: 3, blindStructureId: 1, blind_structure_id: 1, levelNumber: 3, level_number: 3, smallBlind: 75, small_blind: 75, bigBlind: 150, big_blind: 150, ante: 0, isBreak: false, is_break: false, durationSeconds: 1200, duration_seconds: 1200, breakDurationSeconds: 0, break_duration_seconds: 0 },
    { id: 4, blindStructureId: 1, blind_structure_id: 1, levelNumber: 4, level_number: 4, smallBlind: 100, small_blind: 100, bigBlind: 200, big_blind: 200, ante: 25, isBreak: false, is_break: false, durationSeconds: 1200, duration_seconds: 1200, breakDurationSeconds: 0, break_duration_seconds: 0 },
    { id: 5, blindStructureId: 1, blind_structure_id: 1, levelNumber: 5, level_number: 5, smallBlind: 0, small_blind: 0, bigBlind: 0, big_blind: 0, ante: 0, isBreak: true, is_break: true, breakDuration: 10, break_duration_minutes: 10, durationSeconds: 600, duration_seconds: 600, breakDurationSeconds: 600, break_duration_seconds: 600 },
    { id: 6, blindStructureId: 1, blind_structure_id: 1, levelNumber: 6, level_number: 6, smallBlind: 150, small_blind: 150, bigBlind: 300, big_blind: 300, ante: 25, isBreak: false, is_break: false, durationSeconds: 1200, duration_seconds: 1200, breakDurationSeconds: 0, break_duration_seconds: 0 },
  ],
  2: [
    { id: 7, blindStructureId: 2, blind_structure_id: 2, levelNumber: 1, level_number: 1, smallBlind: 50, small_blind: 50, bigBlind: 100, big_blind: 100, ante: 0, isBreak: false, is_break: false, durationSeconds: 720, duration_seconds: 720, breakDurationSeconds: 0, break_duration_seconds: 0 },
    { id: 8, blindStructureId: 2, blind_structure_id: 2, levelNumber: 2, level_number: 2, smallBlind: 100, small_blind: 100, bigBlind: 200, big_blind: 200, ante: 0, isBreak: false, is_break: false, durationSeconds: 720, duration_seconds: 720, breakDurationSeconds: 0, break_duration_seconds: 0 },
    { id: 9, blindStructureId: 2, blind_structure_id: 2, levelNumber: 3, level_number: 3, smallBlind: 200, small_blind: 200, bigBlind: 400, big_blind: 400, ante: 25, isBreak: false, is_break: false, durationSeconds: 720, duration_seconds: 720, breakDurationSeconds: 0, break_duration_seconds: 0 },
  ],
};

let nextStructureId = 3;
let nextLevelId = 10;

// Helper to simulate API delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const mockBlindStructuresApi = {
  getBlindStructures: async (leagueId) => {
    await delay(300);
    const structures = mockBlindStructures.filter(s => s.leagueId === leagueId);
    return {
      success: true,
      data: {
        blindStructures: structures,
      },
    };
  },

  createBlindStructure: async (leagueId, structureData) => {
    await delay(300);
    const newStructure = {
      id: nextStructureId++,
      leagueId,
      ...structureData,
      blind_duration_minutes: structureData.blindDuration,
      break_duration_minutes: structureData.breakDuration,
      break_frequency: structureData.breakFrequency,
      is_default: false,
      isDefault: false,
    };
    mockBlindStructures.push(newStructure);
    mockBlindLevels[newStructure.id] = [];
    return {
      success: true,
      data: {
        blindStructure: newStructure,
      },
    };
  },

  updateBlindStructure: async (leagueId, structureId, structureData) => {
    await delay(300);
    const index = mockBlindStructures.findIndex(s => s.id === structureId);
    if (index !== -1) {
      mockBlindStructures[index] = {
        ...mockBlindStructures[index],
        ...structureData,
        blind_duration_minutes: structureData.blindDuration,
        break_duration_minutes: structureData.breakDuration,
        break_frequency: structureData.breakFrequency,
      };
      return {
        success: true,
        data: {
          blindStructure: mockBlindStructures[index],
        },
      };
    }
    throw new Error('Structure not found');
  },

  deleteBlindStructure: async (leagueId, structureId) => {
    await delay(300);
    mockBlindStructures = mockBlindStructures.filter(s => s.id !== structureId);
    delete mockBlindLevels[structureId];
    return {
      success: true,
    };
  },

  setDefaultBlindStructure: async (leagueId, structureId) => {
    await delay(300);
    // Remove default from all structures of this league
    mockBlindStructures.forEach(s => {
      if (s.leagueId === leagueId) {
        s.isDefault = false;
        s.is_default = false;
      }
    });
    // Set this one as default
    const structure = mockBlindStructures.find(s => s.id === structureId);
    if (structure) {
      structure.isDefault = true;
      structure.is_default = true;
    }
    return {
      success: true,
    };
  },

  getLevels: async (structureId) => {
    await delay(300);
    const levels = mockBlindLevels[structureId] || [];
    return {
      success: true,
      data: {
        levels,
      },
    };
  },

  createLevel: async (structureId, levelData) => {
    await delay(300);
    const newLevel = {
      id: nextLevelId++,
      blindStructureId: structureId,
      blind_structure_id: structureId,
      ...levelData,
      level_number: levelData.levelNumber,
      small_blind: levelData.smallBlind,
      big_blind: levelData.bigBlind,
      is_break: levelData.isBreak,
      duration_seconds: levelData.durationSeconds || 1200,
      break_duration_seconds: levelData.breakDurationSeconds || 600,
      break_duration_minutes: levelData.breakDuration,
    };
    if (!mockBlindLevels[structureId]) {
      mockBlindLevels[structureId] = [];
    }
    mockBlindLevels[structureId].push(newLevel);
    return {
      success: true,
      data: {
        level: newLevel,
      },
    };
  },

  updateLevel: async (structureId, levelId, levelData) => {
    await delay(300);
    const levels = mockBlindLevels[structureId] || [];
    const index = levels.findIndex(l => l.id === levelId);
    if (index !== -1) {
      levels[index] = {
        ...levels[index],
        ...levelData,
        level_number: levelData.levelNumber,
        small_blind: levelData.smallBlind,
        big_blind: levelData.bigBlind,
        is_break: levelData.isBreak,
        break_duration_minutes: levelData.breakDuration,
      };
      return {
        success: true,
        data: {
          level: levels[index],
        },
      };
    }
    throw new Error('Level not found');
  },

  deleteLevel: async (structureId, levelId) => {
    await delay(300);
    if (mockBlindLevels[structureId]) {
      mockBlindLevels[structureId] = mockBlindLevels[structureId].filter(l => l.id !== levelId);
    }
    return {
      success: true,
    };
  },
};

// Check if we should use mock API (when backend is not available)
export const shouldUseMockApi = () => {
  // Use mock API only when explicitly enabled
  return process.env.REACT_APP_USE_MOCK_BLINDS === 'true';
};
